import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import StarCanvas from "@/components/StarCanvas";

export default function PaymentCancel() {
  return (
    <div className="relative min-h-screen bg-[#0B091A] flex items-center justify-center px-4">
      <StarCanvas />
      <div className="relative z-10 glass-card rounded-3xl p-10 sm:p-12 max-w-md w-full text-center">
        <div className="w-16 h-16 rounded-full bg-slate-500/15 border border-slate-400/30 flex items-center justify-center mx-auto mb-6">
          <XCircle size={28} className="text-slate-400" />
        </div>
        <h2 data-testid="payment-cancel-title" className="font-serif text-2xl font-bold text-white mb-2">Checkout canceled</h2>
        <p className="text-sm text-slate-400 mb-8">No charge was made. You can subscribe anytime — your free story is still here.</p>
        <Link
          to="/#pricing"
          data-testid="payment-cancel-back-btn"
          className="px-8 py-3 rounded-full bg-gradient-to-r from-purple-600 to-amber-500 text-white font-semibold text-sm inline-flex items-center gap-2"
        >
          Back to Pricing
        </Link>
      </div>
    </div>
  );
}
